import {apiGet} from "app/shared-components/util/restAPI";

const screenNameRegex= /^[a-z][0-9a-z]*(_[0-9a-z]+)*$/

export const isValidUniqueName = (screenName) => {
    if (!screenName) return false;
    if (screenName.length < 4 || screenName.length > 30) return false;
    return screenNameRegex.test(screenName);
}

export const checkUniqueName= async (name, type) => {
    let url= '/channelentity/checkuniquename?name=' + name + "&type=" + type;
    const apiName = 'CoreAPI';
    const path = url;
    const options = {
        headers: {},
        response: false, // OPTIONAL (return the entire Axios response object instead of only response.data)
    };
    return await apiGet(apiName, path, options);
};

export const isUniqueNameAvailable = (type) => async (name) => {
    const data= await checkUniqueName(name, type);
    return !!(data.valid && data.available);
};

export const loadEntityByUniqueName= async (name, type) => {
    let url= '/channelentity/public/byuniquename?name=' + name + "&type=" + type;
    const apiName = 'PublicAPI';
    const path = url;
    const options = {
        headers: {},
        response: false, // OPTIONAL (return the entire Axios response object instead of only response.data)
    };
    return await apiGet(apiName, path, options);
};
